export default {
    vApp: '1.1.0 - 06/10/2026'
}
